import moment from "moment"

export const shouldShowCourseNumber = (date: string) => {
  return moment(date).isBefore("2018-11-01")
}
